import { GET_WPO_APPOINTMENTS } from '../../queries/User';
import { Instance, SnapshotOut, cast, flow, getRoot, types } from 'mobx-state-tree';
import { RootStoreModel } from '../Root/RootStore';
import { captureException } from '@sentry/react-native';
import { clientFunction } from '../../../config/apollo/client';

const AppointmentStore = types.model('Appointment', {
  appointmentId: types.number,
  companyId: types.string,
  dateFrom: types.string,
  counsellorName: types.string,
  status: types.string,
  timeZone: types.string,
  appointmentModeLabel: types.string,
});
type IAppointmentStore = Instance<typeof AppointmentStore>;

export const AppointmentsStore = types
  .model('AppointmentsStore', {
    list: types.optional(types.array(AppointmentStore), []),
    state: types.optional(types.enumeration(['pending', 'done', 'error']), 'done'),
  })
  .actions(self => {
    const fetch: any = flow(function*() {
      console.log('fetching appointments');
      self.state = 'pending';
      const rootStore = getRoot<Instance<typeof RootStoreModel>>(self);
      const language = rootStore.language.language;
      try {
        const { data } = yield clientFunction(language).query({
          query: GET_WPO_APPOINTMENTS,
        });
        if (data) {
          self.list = cast([]);
          for (const appointment of (data?.getWpoAppointments?.upcomingAppointments || [])) {
            console.log(appointment);
            self.list.push({
              appointmentId: appointment.appointmentId,
              companyId: appointment.companyId,
              dateFrom: appointment.dateFrom,
              counsellorName: appointment.counsellorName,
              status: appointment.status,
              timeZone: appointment.timeZoneCode,
              appointmentModeLabel: appointment.appointmentModeLabel,
            });
          }
        }
        console.log('fetched appointments', self.list.length);
        self.state = 'done';
      } catch (err) {
        self.state = 'error';
        console.error(err);
        captureException(err);
      }
    });
    return  {fetch};
  })
  .views(self => ({
    get sorted(): SnapshotOut<IAppointmentStore>[] {
      return self.list
        .slice()
        .sort((a, b) => a.dateFrom.localeCompare(b.dateFrom));
    },
    get next(): SnapshotOut<IAppointmentStore> | undefined {
      return this.sorted[0];
    },
    get hasAny(): boolean {
      return self.list.length > 0;
    },
    get isDone(): boolean {
      return self.state === 'done';
    },
    get isError(): boolean {
      return self.state === 'error';
    },
    get isPending(): boolean {
      return self.state === 'pending';
    }
  }));
